import * as React from 'react';

import Modal from '../../../shared/components/modal/modal.component';

export interface ICartChangePopupProps {
    isOpen: boolean;
    message?: string;
    defaultButtonMessage?: string;
    cartLinkButtonMessage?: string;
    onClose(): void;
    onGoToCart(): void;
    onRemoveDetectedLines?(): void;
}

/**
 * Presentation-only popup informing the user that their cart was updated on
 * sign-in. Mirrors the legacy header cart-update modal markup and styling.
 */
const CartChangePopup: React.FC<ICartChangePopupProps> = props => (
    <Modal
        isOpen={props.isOpen}
        toggle={props.onClose}
        content={<p>{props.message}</p>}
        defaultButtonAction={props.onRemoveDetectedLines}
        defaultButtonMessage={props.defaultButtonMessage}
        buttons={
            <button className='redirect-btn' onClick={props.onGoToCart}>
                {props.cartLinkButtonMessage}
            </button>
        }
    />
);

export default CartChangePopup;
